var _style, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1013.1 294.1",
    style: {
      enableBackground: "new 0 0 1013.1 294.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#6CD7BB;}\n\t.st2{fill:#FFC19A;}\n\t.st3{fill:#D86A9D;}\n\t.st4{fill:#42CFE0;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -217.6,
    y: -659.8,
    width: 1500,
    height: 1500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.8,109.7c11.1-13.8,28-22.7,47-22.7c16.2,0,32.6,7.2,45.7,20.3l27-27.3c-20.1-20.3-46.8-31.8-72.7-31.8 c-14.9,0-29.4,3.5-42.6,9.8c-14.6,7-27.5,17.5-37.3,30.7l27.7,17.2C218.4,107.2,220.1,108.4,221.8,109.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,28.9v237.7c0,8.3,4.2,15.1,10.1,19.1L86,135.4L16.4,7.6C8.5,11.1,2.5,18.9,2.5,28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.2,185.7c-14.5,14.5-30.1,22.9-48.5,22.9c-19.1,0-36.1-8.9-47.1-22.7c-1.6,1.3-3.3,2.5-5.1,3.6 l-27.8,17.3c17.2,23.8,45,40.5,80,40.5c28.1,0,54.1-12.8,75.8-34.5L317.2,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.8,167.3l-93.8,58.3L86,135.4l36-73.8l106.8,66.5C243.3,137.1,243.3,158.3,228.8,167.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.1,225.7l-97.3,60.5c-8.4,5.2-18.1,4.3-25.2-0.5L86,135.4L135.1,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122,61.6l-36,73.8L16.4,7.6C23,4.8,30.9,4.9,37.8,9.2L122,61.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.6,242.6 376,242.6 376,53.8 413.5,53.8 413.5,205.1 489.6,205.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650,53.8l-70.7,97.6v91.2h-37.5v-91.2C520,121.2,493.3,84,471.5,53.8h46.1l43.2,59.9l42.9-59.9H650z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M746.4,142l84.2,100.6h-48.8l-60.4-72.8c-3.2,3.8-7,8.4-10.8,12.1v60.7h-37.2V53.8h37.2v71.5l64.2-71.5h50.4 L746.4,142z M924.2,142l84.2,100.6h-48.8l-60.4-72.8c-3.2,3.8-7,8.4-10.8,12.1v60.7h-37.2V53.8h37.2v71.5l64.2-71.5h50.4 L924.2,142z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.94a1f237ba9d555b23f4a270c7cf0758.svg";
export { ForwardRef as ReactComponent };